var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#7E0CF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.533 272.917C108.908 275.011 104.961 275.817 100.933 275.817C89.0111 275.817 80.5528 267.439 80.5528 256C80.5528 244.319 89.0111 236.183 101.014 236.183C107.056 236.183 112.131 238.197 116.561 242.628L123.167 236.183C117.85 230.142 109.956 227 100.531 227C82.8889 227 70 239.164 70 256C70 272.836 82.8889 285 100.369 285C108.344 285 116.561 282.583 122.442 277.831V255.356H112.533V272.917Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.176 284.194L193.207 265.667C200.859 262.686 205.209 256.403 205.209 247.864C205.209 235.378 196.026 227.806 181.204 227.806H158.004V284.194H168.476V267.761H181.204C181.929 267.761 182.654 267.761 183.379 267.681L194.898 284.194H206.176ZM194.657 247.864C194.657 254.953 189.904 259.142 180.72 259.142H168.476V236.667H180.72C189.904 236.667 194.657 240.775 194.657 247.864Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280.887 284.194H291.842L266.387 227.806H256.076L230.701 284.194H241.495L247.054 271.144H275.248L280.887 284.194ZM250.598 262.928L261.151 238.278L271.784 262.928H250.598Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M343.964 227.806H320.764V284.194H331.236V267.922H343.964C358.786 267.922 367.969 260.269 367.969 247.864C367.969 235.378 358.786 227.806 343.964 227.806ZM343.48 259.061H331.236V236.667H343.48C352.664 236.667 357.417 240.775 357.417 247.864C357.417 254.953 352.664 259.061 343.48 259.061Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M410.649 275.414V259.867H437.877V251.247H410.649V236.586H441.341V227.806H400.177V284.194H442.469V275.414H410.649Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewlogo);
export default __webpack_public_path__ + "static/media/newlogo.38f56624d78c59697384dde46626bcc7.svg";
export { ForwardRef as ReactComponent };